import { render, staticRenderFns } from "./rPark.vue?vue&type=template&id=2dbd58cd&scoped=true&"
import script from "./rPark.vue?vue&type=script&lang=js&"
export * from "./rPark.vue?vue&type=script&lang=js&"
import style0 from "./rPark.vue?vue&type=style&index=0&id=2dbd58cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbd58cd",
  null
  
)

export default component.exports